import { canAccessPage } from '@/components/acl/can-access-page';
import { getDashboardLink } from '@/utils/get-dashboard-link';
import { useStore } from '@/store';
import { loadProfileData } from '@/services/api/api-services/load-profile';

export default async (to: any, from: any, next: Function) => {
  const store = useStore();
  if (store.authToken) {
    if (!store.isProfileLoaded) {
      try {
        await loadProfileData();
      } catch {
        return next({ path: '/logout' });
      }
    }

    const notAllowedCondition = to.meta && to.meta.aclRules && !canAccessPage(to.meta.aclRules);
    const notFoundCondition = to?.meta?.notFound;

    const user = store.user as any;
    const isEmailVerificationRequired = !user?.emailVerified;
    const isCurrencyRequired = !user?.currencyId;

    if(isEmailVerificationRequired){
      if(from?.name === 'register-email-verification'){
        return next(false);
      }else{
        return next({ name: 'register-email-verification'});
      }
    }

    if(isCurrencyRequired){
      if(from?.name === 'register-currency'){
        return next(false);
      }else{
        return next({ name: 'register-currency'});
      }
    }

    if(notAllowedCondition || notFoundCondition) {
      return next(getDashboardLink(user));
    } else {
      return next();
    }

  }

  return next({ path: '/login', query: { redirect: to.fullPath } });
};
